export var EffortPlanningConfig = /*#__PURE__*/ function(EffortPlanningConfig) {
    EffortPlanningConfig["Task"] = "TASK";
    EffortPlanningConfig["Phase"] = "PROJECT_PHASE";
    return EffortPlanningConfig;
}({});
